import {
  HOTEL_GROUP_SNAPSHOT_REPORT_REQUEST,
  HOTEL_GROUPS_SNAPSHOT_REPORT_ERROR,
  HOTEL_GROUPS_SNAPSHOT_REPORT_RECEIVED,
  HOTEL_GROUPS_SNAPSHOT_REPORT_UNLOAD,
  VENUE_RECEIVED_ERROR,
  VENUE_RECEIVED_REQUEST,
  VENUE_REQUEST,
  VENUE_UNLOAD,
  VENUES_LIST_RECEIVED_ERROR,
  VENUES_LIST_RECEIVED_REQUEST,
  VENUES_LIST_REQUEST,
  VENUES_LIST_UNLOAD,
} from "./types";

export const venues = (
  state = {
    venues: {},
    isFetchingVenues: false,
    fetchVenuesError: false,
    fetchVenuesErrorData: {},
  },
  action
) => {
  switch (action.type) {
    case VENUES_LIST_REQUEST:
      return {
        ...state,
        isFetchingVenues: true,
      };
    case VENUES_LIST_RECEIVED_REQUEST:
      return {
        ...state,
        isFetchingVenues: false,
        venues: action.data,
      };
    case VENUES_LIST_RECEIVED_ERROR:
      return {
        ...state,
        isFetchingVenues: false,
        fetchVenuesErrorData: action.error,
      };
    case VENUES_LIST_UNLOAD:
      return {
        ...state,
        isFetchingVenues: false,
        venues: {},
        fetchVenuesError: false,
        fetchVenuesErrorData: {},
      };
    default:
      return state;
  }
};

export const venue = (
  state = {
    venue: {},
    isFetchingVenue: false,
    fetchVenueError: false,
    fetchVenueErrorData: {},
  },
  action
) => {
  switch (action.type) {
    case VENUE_REQUEST:
      return {
        ...state,
        isFetchingVenue: true,
      };
    case VENUE_RECEIVED_REQUEST:
      return {
        ...state,
        isFetchingVenue: false,
        venue: action.data,
      };
    case VENUE_RECEIVED_ERROR:
      return {
        ...state,
        isFetchingVenue: false,
        fetchVenueErrorData: action.error,
      };
    case VENUE_UNLOAD:
      return {
        ...state,
        isFetchingVenue: false,
        venue: {},
        fetchVenueError: false,
        fetchVenueErrorData: {},
      };
    default:
      return state;
  }
};

export const hotelGroupsSnapshotReport = (
  state = {
    hotelGroupsSnapshotReport: [],
    error: false,
    isFetchingSnapshotReport: false,
    errorData: [],
  },
  action
) => {
  switch (action.type) {
    case HOTEL_GROUP_SNAPSHOT_REPORT_REQUEST:
      return {
        ...state,
        error: false,
        hotelGroupsSnapshotReport: [],
        isFetchingSnapshotReport: true,
      };
    case HOTEL_GROUPS_SNAPSHOT_REPORT_RECEIVED:
      return {
        ...state,
        error: false,
        hotelGroupsSnapshotReport: action.data.data,
        isFetchingSnapshotReport: false,
      };
    case HOTEL_GROUPS_SNAPSHOT_REPORT_ERROR:
      return {
        ...state,
        error: true,
        hotelGroupsSnapshotReport: [],
        isFetchingSnapshotReport: false,
      };
    case HOTEL_GROUPS_SNAPSHOT_REPORT_UNLOAD:
      return {
        ...state,
        hotelGroupsSnapshotReport: [],
        error: false,
        isFetchingSnapshotReport: false,
      };
    default:
      return state;
  }
};
